// material-ui
import { Theme } from '@mui/material/styles';

// project-imports
import { withAlpha } from 'utils/colorUtils';

// ==============================|| OVERRIDES - SNACKBAR ||============================== //

export default function Snackbar(theme: Theme) {
  return {
    MuiSnackbar: {
      styleOverrides: {
        root: {
          '& .MuiAlert-root': {
            '& .MuiAlert-message': {
              marginTop: 4,
              '& .MuiButton-root': {
                marginTop: 2
              }
            },
            '& .MuiAlert-action': {
              '& .MuiButton-root': {
                marginRight: 4,
                marginTop: 0
              },
              '& .MuiIconButton-root': {
                color: theme.vars.palette.background.default,
                '&.MuiIconButton-colorSecondary': {
                  backgroundColor: theme.vars.palette.secondary.main,
                  '&:hover': {
                    backgroundColor: theme.vars.palette.secondary.dark
                  }
                }
              }
            },
            '&:not(.MuiAlert-outlined)': {
              '& .MuiAlert-action': {
                '& .MuiIconButton-root': {
                  '&:hover': {
                    backgroundColor: withAlpha(theme.vars.palette.background.default, 0.25)
                  }
                }
              }
            }
          }
        }
      }
    }
  };
}
